export default "__VITE_ASSET__DyP9ZkRU__"